
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowDialog extends SiteEntityDialog<WorkflowRow, any> {
        protected getFormKey() { return WorkflowForm.formKey; }
        protected getIdProperty() { return WorkflowRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowRow.nameProperty; }
        protected getService() { return WorkflowService.baseUrl; }

        protected form = new WorkflowForm(this.idPrefix);

    }
}